<template>
  <div class="tableCom">
    <div class="tableTitle">
      <span class="col-lg-7 col-md-5 col-xs-8 col-sm-8">标题</span>
      <span class="col-lg-4 col-md-3 hidden-xs hidden-sm">
        <a class="timeSort">时间<span class="sortIcon"></span></a>
      </span>
      <span class="col-lg-1 col-md-1 hidden-xs hidden-sm">操作</span>
    </div>
    <div class="tableCon">
      <p class="tableTr clearfix" v-for="(item,index) in messageData" :key="index">
        <span class="col-lg-7 col-md-5 col-xs-8 col-sm-8">
          <i class="alreadyRead"></i>{{item.noticeTitle}}
        </span>
        <span class="col-lg-4 col-md-3 hidden-xs hidden-sm">{{item.createTime|time}}</span>
        <span class="col-lg-1 col-md-1 hidden-xs hidden-sm" @click="viewNotice(item)"><a>查看</a></span>
      </p>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['messageData','noticeQuery','footerColumnInfos','navigationColumnInfos','paramInfo'],
    data () {
      return {
      }
    },
    created () {
    },
    methods: {
      viewNotice(item){
        this.$router.push({ path: '/notificationDetails', query: { noticeInfo: item,webConfigInfo:this.webConfigInfo,footerColumnInfos:this.footerColumnInfos,navigationColumnInfos:this.navigationColumnInfos,paramInfo:this.paramInfo} })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/notificationTable/index.vue